const menuData = [
  {
    title: "应用总览",
    key: "/app/frame/overview",
  },
  {
    title: "订阅管理",
    key: "/app/frame/subscribe",
  },
  {
    title: "对接方案",
    key: "/app/frame/scheme",
  },
  {
    title: "流量权限",
    key: "/app/frame/trafficpermission",
  },
  {
    title: "日志监控",
    key: "/app/frame/logmonitor",
  },
 
  // {
  //   "title": "文档中心",
  //   "key": "/app/doc",
  //   "children": [
  //     {
  //       "title": "API文档",
  //       "key": "/app/doc/api"
  //     },
  //     {
  //       "title": "接入指南",
  //       "key": "/app/doc/guide"
  //     },
  //     {
  //       "title": "常见问题",
  //       "key": "/app/doc/faq"
  //     }
  //   ]
  // }
];

export default menuData;
